import { PaymentMethodsType } from '@package/core/src/payment/types';

export const PAYMENT_METHODS_QUERY_KEY = 'get-payment-methods';
export const SHOPPING_CART_PAYMENT_METHODS_QUERY_KEY = 'get-shopping-cart-payment-methods';

export interface PaymentMethods {
  affirmEnabled: boolean;
  sezzleEnabled: boolean;
  applePayEnabled: boolean;
  fetchPaymentMethods?: boolean;
}

export const PAYMENT_METHOD_PRIORITY: { [key: string]: number } = {
  [PaymentMethodsType.PayPal]: 1,
  [PaymentMethodsType.ApplePay]: 2,
  [PaymentMethodsType.Sezzle]: 3,
  [PaymentMethodsType.Affirm]: 4,
};
